import { createFileRoute } from '@tanstack/react-router';
import Settings from '../../components/client/Settings';
import StaffPortal from '../../components/portals/StaffPortal';
import { useAuth } from '../../contexts/AuthContext';
import { mockStaffUser } from '../../data/mockData';

export const Route = createFileRoute('/staff/settings')({
  component: StaffSettingsRoute,
});

function StaffSettingsRoute() {
  const { user } = useAuth();
  const content = <Settings user={user ?? mockStaffUser} />;
  return <StaffPortal>{content}</StaffPortal>;
}
